module.exports = __webpack_public_path__ + "static/media/robots.4e3a8153.png";